export const css = {
	root: '_1e3B6qJV',
	' _key': 'apic-theme/apic/variants/aipc2'
};

export default css;
